<template>
  <DE v-if="lang_mode == 'de'" />
  <EN v-else-if="lang_mode == 'en'" />
  <ES v-else-if="lang_mode == 'es'" />
  <FR v-else-if="lang_mode == 'fr'" />
  <IT v-else-if="lang_mode == 'it'" />
  <KO v-else-if="lang_mode == 'ko'" />
  <ZH v-else-if="lang_mode == 'zh'" />
  <ZHTW v-else-if="lang_mode == 'zh-TW'" />

  <JP v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import JP from '@/components/pages/PrivacyProtection/JP.vue';
import DE from '@/components/pages/PrivacyProtection/DE.vue';
import EN from '@/components/pages/PrivacyProtection/EN.vue';
import ES from '@/components/pages/PrivacyProtection/ES.vue';
import FR from '@/components/pages/PrivacyProtection/FR.vue';
import IT from '@/components/pages/PrivacyProtection/IT.vue';
import KO from '@/components/pages/PrivacyProtection/KO.vue';
import ZH from '@/components/pages/PrivacyProtection/ZH.vue';
import ZHTW from '@/components/pages/PrivacyProtection/ZHTW.vue';

export default {
  name: 'PrivacyProtection',
  components: {
    JP,
    DE,
    EN,
    ES,
    FR,
    IT,
    KO,
    ZH,
    ZHTW,
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
    lang_mode() {
      if (this.currentUser) {
        return this.currentUser.language;
      }
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
